module.exports = __webpack_public_path__ + "img/huoban3.d487f46d.png";